"use client";

import * as React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  id: 1,
  name: "Zain Malik",
  text: "The Sultani Smash Burger is a game changer. That fusion of Punjabi spices with a classic American patty is something I didn't know I needed until now.",
  rating: 5
}, {
  id: 2,
  name: "Sarah Jenkins",
  text: "Best halal spot in Irving, hands down. The atmosphere is moody and premium, and the Karahi has that authentic home-cooked depth of flavor.",
  rating: 5
}, {
  id: 3,
  name: "The Ahmed Family",
  text: "We hosted a small event here and the service was impeccable. The dark red aesthetic makes the whole place feel incredibly high-end and exclusive.",
  rating: 5
}, {
  id: 4,
  name: "Marcus Thompson",
  text: "Bold flavors and even bolder decor. You can tell they care about every detail, from the spice levels to the lighting. A must-visit for foodies.",
  rating: 5
}, {
  id: 5,
  name: "Priya Sharma",
  text: "Finally, a place that does fusion right. The Blaze Orange accents and the black-on-black design create such a cool vibe for a late-night dinner.",
  rating: 5
}];
export default function GuestTestimonials() {
  return <section data-section-id="236453" id="street-cred" className="py-24 bg-background relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-20 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/sultani_interior_blur.png')] bg-cover bg-center grayscale" />
      
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-4 tracking-wider uppercase">
            Street Cred
          </h2>
          <p className="text-muted-foreground font-default text-lg">
            Real talk from the people who’ve experienced the boldest Punjabi-American fusion in Irving.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent className="-ml-4 md:-ml-6">
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <Card className="h-full bg-[#1A1A1A] border border-[#8B0000] shadow-2xl hover:shadow-[0_0_20px_rgba(139,0,0,0.3)] transition-all duration-300 rounded-none">
                  <CardContent className="p-8 flex flex-col h-full justify-between">
                    <div>
                      <div className="flex gap-1 mb-8">
                        {Array.from({
                      length: testimonial.rating
                    }).map((_, j) => <Star key={j} className="size-5 text-[#FF6B00] fill-[#FF6B00]" strokeWidth={1} />)}
                      </div>
                      <blockquote className="font-default text-lg md:text-xl text-foreground leading-relaxed mb-8 italic">
                        "{testimonial.text}"
                      </blockquote>
                    </div>
                    <div className="mt-auto">
                      <p className="font-serif text-[20px] font-medium uppercase tracking-widest text-[#FF6B00]">
                        — {testimonial.name}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>

          <div className="flex items-center justify-center gap-4 mt-12">
            <div className="relative size-12">
              <CarouselPrevious className="left-0 top-0 translate-y-0 size-12 bg-[#1A1A1A] border-[#8B0000] hover:bg-[#8B0000] text-foreground shadow-lg rounded-none" />
            </div>
            <div className="relative size-12">
              <CarouselNext className="right-0 top-0 translate-y-0 size-12 bg-[#1A1A1A] border-[#8B0000] hover:bg-[#8B0000] text-foreground shadow-lg rounded-none" />
            </div>
          </div>
        </Carousel>
      </div>
    </section>;
}